
import { Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { startWith, tap } from 'rxjs';
import { MceApiService } from '../../core/mceapi.client.generated';


@Component({
    selector: 'mce-metal-prices',
    imports: [MatCardModule, MatProgressBarModule],
    templateUrl: './metal-prices.component.html'
})
export class MetalPricesComponent {

  private mceApiService = inject(MceApiService);

  private readonly processing = signal(true);


  protected metalPrices = toSignal(
    this.mceApiService.v1MaterialsConductorsPricesLatestHtml().pipe(
      startWith({ html: '' }),
      tap(() => this.processing.set(false))),
    { initialValue: { html: '' } });


  protected readonly viewModel = computed(() => {
    return {

      metalPrices: this.metalPrices().html,

      showProgressBar: this.processing(),
    };
  });

  protected get vm() { return this.viewModel(); }


}
